<script setup>
import { ref } from 'vue'
import logoRed from '@/assets/images/logo-red.png'
import ToTop from './toTop.vue'

// 导航：与设计稿右上「首页 功能 价格 服务 知道」一致
const menuItems = ref([
  { title: '首页', path: '/' },
  { title: '功能', path: '/products' },
  { title: '价格', path: '/pricing' },
  { title: '服务', path: '/solutions' },
  { title: '知道', path: '/about' }
]);

// 友情链接：设计稿里这一行没有「友情链接：」前缀，直接排 5 个链接，中间一根细竖线
const linkList = ref([
  { id: 1, title: "跨境电商ERP软件", link: 'http://www.douples.com/hy/info.aspx?itemid=14'},
  { id: 2, title: "亚马逊VC订单系统", link: 'https://www.aidoully.com/products'},
  { id: 3, title: "跨境电商VC ERP系统", link: 'https://www.aidoully.com/pricing'},
  { id: 4, title: "VC ERP系统开发", link: 'http://www.douples.com/nl/info.aspx?itemid=1139&lcid=3'},
  { id: 5, title: "Amazon VC服务", link: 'https://www.aidoully.com'},
])
</script>

<template>
  <footer class="footer">
    <div class="footer-inner">
      <!-- 第一行：品牌字标靠左、站点导航靠右，二者共用一条水平中线 -->
      <div class="footer-top">
        <img class="footer-logo" :src="logoRed" alt="DOULLY 豆粒" />
        <nav class="footer-nav">
          <router-link
            v-for="item in menuItems"
            :key="item.path"
            :to="item.path"
            class="footer-nav-link"
            active-class="is-active"
          >
            {{ item.title }}
          </router-link>
        </nav>
      </div>

      <p class="footer-title">帮助出海企业管好货和钱</p>

      <div class="footer-divider"></div>

      <ul class="footer-links">
        <template v-for="(item, index) in linkList" :key="item.id">
          <li v-if="index > 0" class="footer-links-sep" aria-hidden="true"></li>
          <li class="footer-links-item">
            <a :href="item.link" target="_blank" rel="noopener noreferrer">{{ item.title }}</a>
          </li>
        </template>
      </ul>

      <p class="footer-copyright">
        Copyright ◎ 2025 深圳达普信科技有限公司. Al Rights Reserved.<a
          class="footer-icp"
          href="https://beian.miit.gov.cn"
          target="_blank"
          rel="noopener noreferrer"
        >粤ICP备15113791号-6</a>
      </p>
    </div>
    <ToTop></ToTop>
  </footer>
</template>

<style scoped>
/*
  按蓝湖设计稿（1920×4296 的第 4014–4296 段）重做。
  设计坐标 → CSS 的对应（内容整体在 1600px 通栏里，视口 1920 时左右各留 160）：
    页脚顶 4014（高 282）
    字标 204×28  @ (160, 4054)      导航右缘 1759，与字标同一中线
    主标语墨迹 4114–4149（字号 ≈38，重体）
    通栏细线 y=4184（1px）
    友情链接 4210–4225，版权 4255–4269，页脚底 4295
  下面 40 / 24 / 30 / 22 / 25 / 24 这几段间距加起来刚好 282。 */
.footer {
  padding: 40px 20px 24px;
  background-color: #000000;
  font-family: 'PingFang SC', -apple-system, BlinkMacSystemFont, 'Helvetica Neue', sans-serif;
}

.footer-inner {
  max-width: 1600px;
  margin: 0 auto;
}

/* ---------- 字标 + 导航 ---------- */
.footer-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* logo-red.png 本身就是设计稿里那个红色字标（#F4333C，与设计取色完全一致），
   490×64 无内边距，按高 28 缩放即可 */
.footer-logo {
  display: block;
  height: 28px;
  width: auto;
}

.footer-nav {
  display: flex;
  align-items: center;
}

.footer-nav-link {
  font-size: 14px;
  line-height: 20px;
  color: #ffffff;
  text-decoration: none;
  white-space: nowrap;
  transition: color 0.2s ease;
}

/* 设计稿里导航项之间没有「|」，是 24px 的纯间距 */
.footer-nav-link + .footer-nav-link {
  margin-left: 24px;
}

.footer-nav-link:hover,
.footer-nav-link.is-active {
  color: #f4333c;
}

/* ---------- 主标语 ---------- */
.footer-title {
  margin: 24px 0 0;
  font-family: 'DingTalk-JinBuTi', 'PingFang SC', -apple-system, BlinkMacSystemFont, sans-serif;
  font-weight: normal;
  font-size: 38px;
  line-height: 48px;
  color: #ffffff;
}

/* ---------- 通栏细线 ---------- */
.footer-divider {
  height: 1px;
  margin-top: 30px;
  background-color: #3f3f48;
}

/* ---------- 友情链接 ---------- */
.footer-links {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 18px;
  margin: 22px 0 0;
  padding: 0;
  list-style: none;
  font-size: 14px;
  line-height: 20px;
}

.footer-links-item {
  display: flex;
  align-items: center;
}

.footer-links a {
  color: #9ca3af;
  text-decoration: none;
  transition: color 0.2s ease;
}

.footer-links a:hover {
  color: #ffffff;
}

/* 设计稿里的竖线是 1px 宽、16px 高、比正文更暗的一道 */
.footer-links-sep {
  width: 1px;
  height: 16px;
  background-color: #202024;
}

/* ---------- 版权 ---------- */
.footer-copyright {
  margin: 25px 0 0;
  font-size: 14px;
  line-height: 20px;
  color: #9ca3af;
}

.footer-icp {
  color: #9ca3af;
  text-decoration: none;
  cursor: pointer;
  transition: color 0.2s ease;
}

.footer-icp:hover {
  color: #ffffff;
}

/* ---------- 响应式 ---------- */
@media (max-width: 1024px) {
  .footer-title {
    font-size: 32px;
    line-height: 42px;
  }
}

@media (max-width: 768px) {
  .footer {
    padding: 32px 20px 20px;
  }

  /* 窄屏放不下「字标 + 一排导航」，导航折到字标下面 */
  .footer-top {
    flex-direction: column;
    align-items: flex-start;
  }

  .footer-nav {
    flex-wrap: wrap;
    row-gap: 8px;
    margin-top: 18px;
  }

  .footer-title {
    margin-top: 20px;
    font-size: 26px;
    line-height: 36px;
  }

  .footer-divider {
    margin-top: 24px;
  }

  .footer-links {
    gap: 12px;
    margin-top: 18px;
    font-size: 13px;
  }

  .footer-copyright {
    margin-top: 16px;
    font-size: 12px;
    line-height: 18px;
  }
}
</style>
